import Header from '@components/Header';
import { PaymentMethod } from '@models/order';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useExecuteFingerPay from './hooks/useExecuteFingerPay';

interface Params {
    orderNo: string;
    mallId: string;
    requestedAt: string;
    hashString: string;
    itemName: string;
    paymentAmount: number;
    returnUri: string;
    paymentMethod: PaymentMethod;
}

const FingerPayActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    useExecuteFingerPay(params);
    return (<AppScreen>
        <Header title='핑거페이' />
    </AppScreen>);
};

export default FingerPayActivity;
